import { render } from "./idle-overlay-view.vue?vue&type=template&id=5700b2a8&ts=true&lang=pug"
import script from "./idle-overlay-view.vue?vue&type=script&lang=ts"
export * from "./idle-overlay-view.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__